<template>
    <div id="new-fund-destinations">
        <section class="section section-padding">
            <div class="container">
                <div class="section-heading heading-left mb-0">
                    <span class="subtitle primary">
                        Destino de los recursos.
                    </span>
                    <!-- WEB -->
                    <div class="row">
                        <div class="col-lg-11 mb--30">
                            <h2 class="font-weight-100 text-wrap-balance">
                                Construye un portafolio de créditos que, 
                                a través de la <span class="bold">inclusión financiera,</span>
                                combaten el <span class="bold">cambio climático</span>
                                y generan <span class="bold">bienestar social.</span>
                            </h2>
                        </div>
                        <div class="col-lg-12">
                            <div class="row web-destinations">
                                <div @click.stop="goToPage('forProductsPage')" class="col-lg-4 col-xl-4 col-sm-12 col-md-6 clickable" data-sal="slide-up"
                                    data-sal-duration="1000" data-sal-delay="100">
                                    <LoanTypeCard 
                                        title="Crédito Ecotecnologías." 
                                        avatar="ecotecnologia"
                                        :description="'Financiamiento de equipos que reducen la huella de carbono. Paneles y calentadores solares, vehículos eléctricos, entre otros.'"                                            
                                        bgImg="ecotecnologia" />
                                </div>
                                <div @click.stop="goToPage('forPersonalPage')" class="col-lg-4 col-xl-4 col-sm-12 col-md-6 clickable" data-sal="slide-up"
                                    data-sal-duration="1000" data-sal-delay="200">
                                    <LoanTypeCard 
                                        title="Crédito Personal." 
                                        avatar="personal"
                                        :description="'Recursos oportunos para mejorar la vida de los mexicanos. Vivienda, salud, educación, estrés financiero y micronegocios.'"
                                        bgImg="personal" />
                                </div>
                                <div @click.stop="goToPage('forBusinessPage')" class="col-lg-4 col-xl-4 col-sm-12 col-md-6 clickable" data-sal="slide-up"
                                    data-sal-duration="1000" data-sal-delay="300">
                                    <LoanTypeCard 
                                        title="Crédito PYME." 
                                        avatar="pyme"
                                        :description="'Capital de trabajo para empresas que combaten el cambio climático y que generan bienestar social.'" 
                                        bgImg="pyme" />
                                </div>
                            </div>
                            <!-- MOBILE -->
                            <div class="mobile-destinations">
                                <slick :options="slickOptions">
                                    <div @click.stop="goToPage('forProductsPage')" class="col-12 clickable">
                                        <LoanTypeCard 
                                        title="Crédito Ecotecnologías." 
                                        avatar="ecotecnologia"
                                        :description="'Financiamiento de equipos que reducen la huella de carbono. Paneles y calentadores solares, vehículos eléctricos, entre otros.'"                                            
                                        bgImg="ecotecnologia" />
                                    </div>
                                    <div @click.stop="goToPage('forPersonalPage')" class="col-12 clickable">
                                        <LoanTypeCard 
                                        title="Crédito Personal." 
                                        avatar="personal"
                                        :description="'Recursos oportunos para mejorar la vida de los mexicanos. Vivienda, salud, educación, estrés financiero y micronegocios.'"
                                        bgImg="personal" />
                                    </div>
                                    <div @click.stop="goToPage('forBusinessPage')" class="col-12 clickable">
                                        <LoanTypeCard 
                                            title="Crédito PYME." 
                                            avatar="pyme"
                                            :description="'Capital de trabajo para empresas que combaten el cambio climático y que generan bienestar social.'" 
                                            bgImg="pyme" />
                                    </div>
                                </slick>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ImageCard from './partials/image-card.vue';
import LoanTypeCard from './partials/loan-type-card.vue';
import Slick from 'vue-slick';
export default {
    name: "FundDestinations",
    components: {
        ImageCard,
        Slick,
        LoanTypeCard
    },
    data() {
        return {
            slickOptions: {
                infinite: true,
                autoplay: true,
                arrows: false,
                dots: true,
                slidesToShow: 1,
                responsive: [
                    {
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            },
        }
    }
}

</script>

<style scoped>
.mobile-destinations {
    display: none;
}

.web-destinations {
    display: flex;
}
@media only screen and (max-width: 575px) {
    .mobile-destinations {
        display: block;
    }

    .web-destinations {
        display: none;
    }
}
</style>